import { css } from "@emotion/react";

export const loadingStyles = css`
  display: flex;
  justify-content: center;
  padding: 3rem;
  font-size: 3em;
`;
